import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';

import { Button } from '@salesforce/design-system-react';

import { FormattedHeading } from '../../../i18n/components/';
import { SelectAgainRow, SelectAgainEditor } from '../';

import { FlagContext } from '../../../flags/Flags';
import { withSession } from '../../../i18n/containers/AppInit.js';

import './SelectionRulesPanel.scss';

class SelectionRulesPanel extends Component {
  availableAssetTypes() {
    if (this.props.rules.fatigue) {
      const currentRuleAssetTypes = this.props.rules.fatigue.map(
        rule => rule.asset_type
      );
      return this.props.assetTypes
        .filter(assetType => !assetType.parent_class_id)
        .map(type => type.type)
        .filter(type => currentRuleAssetTypes.indexOf(type) < 0);
    }
    return [];
  }

  addNewRule() {
    const assetTypes = this.availableAssetTypes();
    let fatigue = [];
    if (this.props.rules.fatigue) {
      fatigue = [...this.props.rules.fatigue];
    }

    if (assetTypes.length > 0) {
      const assetType = assetTypes[0];
      fatigue.push({
        asset_type: assetType,
        open: 0,
        click: 0,
        max_selection: -1
      });
      this.props.actions.updateRules({
        ...this.props.rules,
        fatigue
      });
    }
  }

  deleteRule(rule) {
    const fatigue = this.props.rules.fatigue.filter(
      existingRule => existingRule.asset_type !== rule.asset_type
    );
    if (fatigue.length !== this.props.rules.fatigue.length) {
      this.props.actions.updateRules({
        ...this.props.rules,
        fatigue
      });
    }
  }

  updateRules(assetType, update) {
    const { fatigue } = this.props.rules;
    const idx = fatigue.findIndex(rule => rule.asset_type === assetType);

    if (idx >= 0) {
      const rule = fatigue[idx];
      const updatedFatigue = fatigue.slice(0);
      updatedFatigue[idx] = { ...rule, ...update };

      this.props.actions.updateRules({
        ...this.props.rules,
        fatigue: updatedFatigue
      });
    }
  }

  defaultRule() {
    const defaultRule =
      this.props.rules.fatigue &&
      this.props.rules.fatigue.find(rule => rule.asset_type === 'default');
    return defaultRule ? defaultRule : { open: 0, click: 0, max_selection: -1 };
  }

  assetTypeRules() {
    const rules =
      this.props.rules.fatigue &&
      this.props.rules.fatigue.filter(rule => rule.asset_type !== 'default');
    return rules || [];
  }

  saveRules(session) {
    return () => {
      let fatigue = [];
      if (this.props.rules.fatigue) {
        fatigue = [...this.props.rules.fatigue];
      }
      this.props.actions.saveRules(
        {
          ...this.props.rules,
          fatigue
        },
        { ruleType: 'fatigue', cToken: session.cToken }
      );
    };
  }

  dirty() {
    return (
      JSON.stringify(this.props.rules.fatigue) !==
      JSON.stringify(this.props.loadedRules.fatigue)
    );
  }

  saveAllowed(flags) {
    return !(flags && flags.isReadonly) && this.dirty();
  }

  render() {
    const { formatMessage } = this.props.intl;
    const saveRuleLabel = formatMessage({
      id: 'components.ecs.rules.save'
    });
    const cancelRuleLabel = formatMessage({
      id: 'components.ecs.rules.cancel'
    });

    const defaultRule = this.defaultRule();
    const otherRules = this.assetTypeRules();
    const defaultHeaderId = otherRules.length
      ? 'components.ecs.rules.selection.defaultOthers'
      : 'components.ecs.rules.selection.defaultAll';

    return withSession(session => {
      return (
        <FlagContext.Consumer>
          {flags => (
            <div className="slds-grid slds-wrap">
              <div className="slds-form selection-panel">
                <div className="selection-panel-header">
                  <p>
                    <FormattedMessage id="components.ecs.rules.selection.subHeader" />
                  </p>
                  <FormattedHeading id={defaultHeaderId} />
                </div>
                <SelectAgainRow
                  {...defaultRule}
                  actions={this.props.actions}
                  assetType="default"
                  loadedFatigueRules={this.props.loadedRules.fatigue}
                  onRuleChange={update => this.updateRules('default', update)}
                />
                <div className="selection-panel-header">
                  <FormattedHeading id="components.ecs.rules.selection.byClass" />
                </div>
                <SelectAgainEditor
                  actions={this.props.actions}
                  selectAgainRules={this.assetTypeRules()}
                  availableAssetTypes={this.availableAssetTypes()}
                  loadedFatigueRules={this.props.loadedRules.fatigue}
                  onAddRule={this.addNewRule.bind(this)}
                  onDeleteRule={this.deleteRule.bind(this)}
                  onRuleChange={this.updateRules.bind(this)}
                />
                <div className="footer-button-actions">
                  <Button
                    label={cancelRuleLabel}
                    disabled={!this.saveAllowed(flags)}
                    variant="neutral"
                    onClick={this.props.openUnsavedChangesModal}
                  />
                  <Button
                    id="fatigueRulesSaveButton"
                    label={saveRuleLabel}
                    disabled={!this.saveAllowed(flags)}
                    variant="brand"
                    onClick={this.saveRules(session)}
                  />
                </div>
              </div>
            </div>
          )}
        </FlagContext.Consumer>
      );
    });
  }
}

SelectionRulesPanel.propTypes = {
  actions: PropTypes.object,
  assetTypes: PropTypes.array,
  rules: PropTypes.object,
  loadedRules: PropTypes.object,
  history: PropTypes.object,
  intl: intlShape.isRequired
};

export default injectIntl(SelectionRulesPanel);
